/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/* eslint-enable import/no-unresolved, import/default */
import jsonConfigurationTemplate from './json-configuration.tpl.html';

/*@ngInject*/
export default function JsonConfigurationStatusTableConfig($q, $mdDialog, types, utils, userService, configurationService) {

    var service = {
        getConfig: getConfig
    };

    return service;

    function getConfig(isGroup) {      
        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var scope = types.authority[authority].scope;

        var tableConfiguration = {

            scope: scope,
            tableTitle: 'configuration-table.status-table',

            columns: [
                {
                    key: 'configurationLastCheckTime',
                    title: 'configuration-table.status-check-time',
                    time: true,
                    sort: true
                },
                {
                    key: 'gatewayGroupName',
                    title: 'configuration-table.gw-group-name',
                    hideIf: !isGroup
                },
                {
                    key: 'name',
                    title: 'gateway.name'
                },
                {
                    key: 'mac',
                    title: 'gateway.mac'
                },
                {
                    key: 'gatewayModelName',
                    title: 'gateway-model.gateway-model',
                    sort: true
                },
                {
                    key: 'configurationTimestamp',
                    title: 'configuration-table.last-update-time',
                    time: true,
                    sort: true
                },
                {
                    key: 'configurationContent',
                    title: 'configuration-table.configuration',
                    button: true,
                    tooltip: 'configuration.view-configuration',
                    action: ($event, entity) => viewConfiguration($event, entity.configurationContent),
                }
            ],

            loadEntities: (entities) => {
                var allEntities = [];
                var tasks = [];
                entities.forEach((entity) => {
                    let entityWithConfiguration = entity;
                    tasks.push(configurationService.getJsonConfiguration(entity.id.id).then(
                        function success(response) {
                            entityWithConfiguration.configurationContent = response.content;
                            entityWithConfiguration.configurationTimestamp = response.timestamp;
                            entityWithConfiguration.configurationLastCheckTime = new Date();
                            allEntities.push(entityWithConfiguration);
                        }, function fail() {
                            entityWithConfiguration.configurationTimestamp = "NO CONFIGURATION FOUND";
                            entityWithConfiguration.configurationLastCheckTime = new Date();
                            allEntities.push(entityWithConfiguration);
                        }
                    ));
                }
                );
                return $q.all(tasks).then(function success() {
                    return allEntities;
                }, function fail() {
                });
            }
        };

        function viewConfiguration($event, configurationContent) {
            $mdDialog.show({
                controller: 'ViewJsonConfigurationController',
                controllerAs: 'vm',
                templateUrl: jsonConfigurationTemplate,
                multiple: true,
                skipHide: true,
                preserveScope: true,
                clickOutsideToClose: true,
                autoWrap: true,
                parent: angular.element('.tk-status-table md-dialog-content'),
                locals: {
                    configurationContent: configurationContent
                },
                targetEvent: $event
            }).then(() => {
            }, () => {
            });
        }

        utils.tableConfigDefaults(tableConfiguration);
        return tableConfiguration;
    }
}


// WEBPACK FOOTER //
// ./src/app/json-configuration/json-configuration-status-table.config.js